module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/categories/sports_coaching-a94df28565c3f82ec0b735f84254ca6b.png";